import { JSX } from 'solid-js';

function ToggleList<T>(props: {
  items: T[];
  showCount: number;
  ulRef: () => HTMLUListElement;
  buttonClass?: string;
  buttonWrapClass?: string;
  children: (items: Accessor<T[]>) => JSX.Element;
}) {
  const [show, setShow] = createSignal(false);
  const toggleShow = () => {
    setShow((pre) => !pre);
    if (!show()) {
      requestAnimationFrame(() => {
        props.ulRef()?.scrollIntoView({ block: 'center' });
      });
    }
  };
  const showBtn = () => {
    return props.items.length > props.showCount;
  };
  const list = createMemo(() => {
    return show() ? props.items : props.items.slice(0, props.showCount);
  });
  return (
    <>
      {props.children(list)}
      {showBtn() && (
        <div class={props.buttonWrapClass}>
          <Button
            class={`w-full !mt-1 text-sm font-semibold text-neutral-main3 ${props.buttonClass || ''}`}
            onClick={toggleShow}
          >
            {show() ? t('Show Less') : t('Show More')}
            <IconArrow06 class={`size-6 ${show() ? 'rotate-180' : ''}`} />
          </Button>
        </div>
      )}
    </>
  );
}

export default ToggleList;
